<template>
  <div class="container ">
    <form action="" @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> البيانات الاساسية </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="form-inline">
            <div class="row">
                 <div class="col-4 ">
                <div class="form-group ">
                  <label for="">كود الصلاحية</label>
                  <input
                  disabled
                    type="text"
                    class="form-control"
                    v-model="id"
                  
                  />
                </div>
                </div>
              <div class="col-6 offset-2">
                <div class="form-group ">
                  <label for="">اسم الصلاحية</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.roleName.$model"
                    :class="{
                      'is-invalid': $v.roleName.$error,
                      'is-valid': !$v.roleName.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.roleName.required">هذا الحقل مطلوب</span>
                    <span v-if="!$v.roleName.minLength"
                      >يجب ان يحتوى على الاقل على{{
                        $v.roleName.$params.minLength.min
                      }}</span
                    >
                    <span v-if="!$v.roleName.maxLength"
                      >اقصى عدد مسموح
                      {{ $v.roleName.$params.maxLength.max }} حرف
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الطلاب </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="std_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="std_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="std_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="std_delete"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الطباعة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="std_print"
                />
              </div>
            </div>
          </div>
        </div>
      </div> 

       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> السائقين </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="driver_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="driver_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="driver_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="driver_delete"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الطباعة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="driver_print"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الحافلات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="bus_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="bus_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="bus_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="bus_delete"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الطباعة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="bus_print"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> صيانة الحافلات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="busM_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="busM_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="busM_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="busM_delete"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الطباعة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="busM_print"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> تتبع الحافلات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2 offset-10">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="busM_Main"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الايرادات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="income_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="income_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="income_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="income_delete"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الطباعة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="income_print"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> المصروفات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="outcome_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="outcome_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="outcome_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="outcome_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> التقارير </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">مجموع الاشتراكات</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="Report_subscribe"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">حسابات السائقين</label>
                <input type="checkbox" class="form-control" v-model="Report_driverAccounts" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">المدنين بالحافلة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="Report_depitByBus"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">المسددين بالحافلة</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="Report_creditByBus"
                />
              </div>
            </div>
                  <div class="col-2">
              <div class="form-inline ">
                <label for=""> كشف حساب</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="Report_paymentsStd"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

       <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الفصول الدراسية </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="classes_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="classes_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="classes_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="classes_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> المدن </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="cities_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="cities_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="cities_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="cities_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

            <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الاحياء </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="district_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="district_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="district_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="district_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

                  <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الجامعات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="college_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="college_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="college_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="college_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      
                  <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> المستخدمين </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="user_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="user_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="user_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="user_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

            
                  <div class="card">
        <div class="card-header">
          <h6>
            <i class="fa fa-address-book"></i
            ><span class="tab-txt"> الصلاحيات </span>
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الصفحة الرئيسية</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="role_Main"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الاضافة</label>
                <input type="checkbox" class="form-control" v-model="role_add" />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">التعديل</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="role_update"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="form-inline ">
                <label for="">الحذف</label>
                <input
                  type="checkbox"
                  class="form-control"
                  v-model="role_delete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
              <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-cog"></i><span class="tab-txt"> التحكم </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="submitStatus === 'انتظار'"
              >
              <b-spinner
v-if="busy"
small
type="grow"
style="margin-bottom: 3px;"
></b-spinner>
              <i class="fa fa-paper-plane"></i>
               <span> {{submitStatus}} </span>
              </button>
               <b-button
                class="btn btn-info mr-3"
                type="button"
                to="/roles"
              >
              <i class="fa fa-undo"></i>
               <span> عودة </span>
              </b-button>
            </div>
          </div>
        </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import indexLayout from "../../layouts/indexLayout.vue";

import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: "createRole",
  data() {
    return {
      id:0,
      roleName: "",
      std_Main: "",
      std_add: "",
      std_update: "",
      std_delete: "",
      std_print: "",
      driver_Main: "",
      driver_add: "",
      driver_update: "",
      driver_delete: "",
      driver_print: "",
      bus_Main: "",
      bus_add: "",
      bus_update: "",
      bus_delete: "",
      bus_print: "",
      busM_Main: "",
      busM_add: "",
      busM_update: "",
      busM_delete: "",
      busM_print: "",
      busF_Main: "",
      income_Main: "",
      income_add: "",
      income_update: "",
      income_delete: "",
      income_print: "",
      outcome_Main: "",
      outcome_add: "",
      outcome_update: "",
      outcome_delete: "",
      Report_subscribe: "",
      Report_driverAccounts: "",
      Report_depitByBus: "",
      Report_creditByBus: "",
      Report_paymentsStd: "",
      classes_Main: "",
      classes_add: "",
      classes_update: "",
      classes_delete: "",
      cities_Main: "",
      cities_add: "",
      cities_update: "",
      cities_delete: "",
      district_Main: "",
      district_add: "",
      district_update: "",
      district_delete: "",
      college_Main: "",
      college_add: "",
      college_update: "",
      college_delete: "",
      user_Main: "",
      user_add: "",
      user_update: "",
      user_delete: "",
      role_Main: "",
      role_add: "",
      role_update: "",
      role_delete: "",
      busy:false,
      submitStatus: "حفظ",
    };
  },
  validations: {
    roleName: { required, minLength: minLength(2), maxLength: maxLength(20) },
  },
  methods: {
    ...mapActions("rolesMod", ["updateData"]),
 loadStd(){
       this.id = this.$route.params.id;
       var std  =  this.$store.getters['rolesMod/getTodoById'](this.id);
      this.id = std['id']; 
this.roleName = std['roleName'] ;                      
this.std_Main = std['std_Main'] == 1 ? true : false ;
this.std_add = std['std_add'] == 1 ? true : false ;
this.std_update = std['std_update'] == 1 ? true : false ;
this.std_delete = std['std_delete'] == 1 ? true : false ;
this.std_print = std['std_print'] == 1 ? true : false ;
this.driver_Main = std['driver_Main'] == 1 ? true : false ;
this.driver_add = std['driver_add'] == 1 ? true : false ;
this.driver_update = std['driver_update'] == 1 ? true : false ;
this.driver_delete = std['driver_delete'] == 1 ? true : false ;
this.driver_print = std['driver_print'] == 1 ? true : false ;
this.bus_Main = std['bus_Main'] == 1 ? true : false ;
this.bus_add = std['bus_add'] == 1 ? true : false ;
this.bus_update = std['bus_update'] == 1 ? true : false ;
this.bus_delete = std['bus_delete'] == 1 ? true : false ;
this.bus_print = std['bus_print'] == 1 ? true : false ;
this.busM_Main = std['busM_Main'] == 1 ? true : false ;
this.busM_add = std['busM_add'] == 1 ? true : false ;
this.busM_update = std['busM_update'] == 1 ? true : false ;
this.busM_delete = std['busM_delete'] == 1 ? true : false ;
this.busM_print = std['busM_print'] == 1 ? true : false ;
this.busF_Main = std['busF_Main'] == 1 ? true : false ;
this.income_Main = std['income_Main'] == 1 ? true : false ;
this.income_add = std['income_add'] == 1 ? true : false ;
this.income_update = std['income_update'] == 1 ? true : false ;
this.income_delete = std['income_delete'] == 1 ? true : false ;
this.income_print = std['income_print'] == 1 ? true : false ;
this.outcome_Main = std['outcome_Main'] == 1 ? true : false ;
this.outcome_add = std['outcome_add'] == 1 ? true : false ;
this.outcome_update = std['outcome_update'] == 1 ? true : false ;
this.outcome_delete = std['outcome_delete'] == 1 ? true : false ;
this.Report_subscribe = std['Report_subscribe'] == 1 ? true : false ;
this.Report_driverAccounts = std['Report_driverAccounts'] == 1 ? true : false ;
this.Report_depitByBus = std['Report_depitByBus'] == 1 ? true : false ;
this.Report_creditByBus = std['Report_creditByBus'] == 1 ? true : false ;
this.Report_paymentsStd = std['Report_paymentsStd'] == 1 ? true : false ;
this.classes_Main = std['classes_Main'] == 1 ? true : false ;
this.classes_add = std['classes_add'] == 1 ? true : false ;
this.classes_update = std['classes_update'] == 1 ? true : false ;
this.classes_delete = std['classes_delete'] == 1 ? true : false ;
this.cities_Main = std['cities_Main'] == 1 ? true : false ;
this.cities_add = std['cities_add'] == 1 ? true : false ;
this.cities_update = std['cities_update'] == 1 ? true : false ;
this.cities_delete = std['cities_delete'] == 1 ? true : false ;
this.district_Main = std['district_Main'] == 1 ? true : false ;
this.district_add = std['district_add'] == 1 ? true : false ;
this.district_update = std['district_update'] == 1 ? true : false ;
this.district_delete = std['district_delete'] == 1 ? true : false ;
this.college_Main = std['college_Main'] == 1 ? true : false ;
this.college_add = std['college_add'] == 1 ? true : false ;
this.college_update = std['college_update'] == 1 ? true : false ;
this.college_delete = std['college_delete'] == 1 ? true : false ;
this.user_Main = std['user_Main'] == 1 ? true : false ;
this.user_add = std['user_add'] == 1 ? true : false ;
this.user_update = std['user_update'] == 1 ? true : false ;
this.user_delete = std['user_delete'] == 1 ? true : false ;
this.role_Main = std['role_Main'] == 1 ? true : false ;
this.role_add = std['role_add'] == 1 ? true : false ;
this.role_update = std['role_update'] == 1 ? true : false ;
this.role_delete = std['role_delete'] == 1 ? true : false ;
     
   },
    async submit() {
      this.$v.$touch();
      this.busy=true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy=false;
      } else {
        var std = {
id:this.id,
roleName:this.roleName,
std_Main:this.std_Main == true ? 1 :0,
std_add:this.std_add == true ? 1 :0,
std_update:this.std_update == true ? 1 :0,
std_delete:this.std_delete == true ? 1 :0,
std_print:this.std_print == true ? 1 :0,
driver_Main:this.driver_Main == true ? 1 :0,
driver_add:this.driver_add == true ? 1 :0,
driver_update:this.driver_update == true ? 1 :0,
driver_delete:this.driver_delete == true ? 1 :0,
driver_print:this.driver_print == true ? 1 :0,
bus_Main:this.bus_Main == true ? 1 :0,
bus_add:this.bus_add == true ? 1 :0,
bus_update:this.bus_update == true ? 1 :0,
bus_delete:this.bus_delete == true ? 1 :0,
bus_print:this.bus_print == true ? 1 :0,
busM_Main:this.busM_Main == true ? 1 :0,
busM_add:this.busM_add == true ? 1 :0,
busM_update:this.busM_update == true ? 1 :0,
busM_delete:this.busM_delete == true ? 1 :0,
busM_print:this.busM_print == true ? 1 :0,
busF_Main:this.busF_Main == true ? 1 :0,
income_Main:this.income_Main == true ? 1 :0,
income_add:this.income_add == true ? 1 :0,
income_update:this.income_update == true ? 1 :0,
income_delete:this.income_delete == true ? 1 :0,
income_print:this.income_print == true ? 1 :0,
outcome_Main:this.outcome_Main == true ? 1 :0,
outcome_add:this.outcome_add == true ? 1 :0,
outcome_update:this.outcome_update == true ? 1 :0,
outcome_delete:this.outcome_delete == true ? 1 :0,
Report_subscribe:this.Report_subscribe == true ? 1 :0,
Report_driverAccounts:this.Report_driverAccounts == true ? 1 :0,
Report_depitByBus:this.Report_depitByBus == true ? 1 :0,
Report_creditByBus:this.Report_creditByBus == true ? 1 :0,
Report_paymentsStd:this.Report_paymentsStd == true ? 1 :0,
classes_Main:this.classes_Main == true ? 1 :0,
classes_add:this.classes_add == true ? 1 :0,
classes_update:this.classes_update == true ? 1 :0,
classes_delete:this.classes_delete == true ? 1 :0,
cities_Main:this.cities_Main == true ? 1 :0,
cities_add:this.cities_add == true ? 1 :0,
cities_update:this.cities_update == true ? 1 :0,
cities_delete:this.cities_delete == true ? 1 :0,
district_Main:this.district_Main == true ? 1 :0,
district_add:this.district_add == true ? 1 :0,
district_update:this.district_update == true ? 1 :0,
district_delete:this.district_delete == true ? 1 :0,
college_Main:this.college_Main == true ? 1 :0,
college_add:this.college_add == true ? 1 :0,
college_update:this.college_update == true ? 1 :0,
college_delete:this.college_delete == true ? 1 :0,
user_Main:this.user_Main == true ? 1 :0,
user_add:this.user_add == true ? 1 :0,
user_update:this.user_update == true ? 1 :0,
user_delete:this.user_delete == true ? 1 :0,
role_Main:this.role_Main == true ? 1 :0,
role_add:this.role_add == true ? 1 :0,
role_update:this.role_update == true ? 1 :0,
role_delete:this.role_delete == true ? 1 :0,
        };
        await this.updateData(std);

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.submitStatus = "تم الحفظ";
        }, 500);
        this.busy=false;
      }
    },
  },
  created() {
    this.$emit("update:layout", indexLayout);
    this.loadStd();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
span {
  font-size: 12px;
}
input[type="checkbox"] {
  width: 20px;
}
</style>
